import { portalCustomerApiSlice } from "./portalCustomerApiSlice";

export const portalAuthApiSlice = portalCustomerApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    resolvePortal: builder.query({
      query: (subdomain) => `/api/portal/v1/public/resolve/?subdomain=${encodeURIComponent(subdomain)}`,
    }),
    portalLogin: builder.mutation({
      query: (body) => ({
        url: "/api/portal/v1/auth/login/",
        method: "POST",
        body,
      }),
    }),
    portalAutoLogin: builder.query({
      query: (subdomain) => `/api/portal/v1/auth/autologin/?subdomain=${encodeURIComponent(subdomain)}`,
    }),
    portalRefresh: builder.mutation({
      query: (subdomain) => ({
        url: "/api/portal/v1/auth/refresh/",
        method: "POST",
        body: { subdomain },
      }),
    }),
    portalLogoutApi: builder.mutation({
      query: (subdomain) => ({
        url: "/api/portal/v1/auth/logout/",
        method: "POST",
        body: { subdomain },
      }),
    }),
    portalAcceptInvite: builder.mutation({
      query: (body) => ({
        url: "/api/portal/v1/auth/accept_invite/",
        method: "POST",
        body,
      }),
    }),
    portalRequestPasswordReset: builder.mutation({
      query: (body) => ({
        url: "/api/portal/v1/auth/request_password_reset/",
        method: "POST",
        body,
      }),
    }),
    portalConfirmPasswordReset: builder.mutation({
      query: (body) => ({
        url: "/api/portal/v1/auth/confirm_password_reset/",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useResolvePortalQuery,
  useLazyResolvePortalQuery,
  usePortalAutoLoginQuery,
  useLazyPortalAutoLoginQuery,
  usePortalLoginMutation,
  usePortalRefreshMutation,
  usePortalLogoutApiMutation,
  usePortalAcceptInviteMutation,
  usePortalRequestPasswordResetMutation,
  usePortalConfirmPasswordResetMutation,
} = portalAuthApiSlice;
